var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"qr_wrapper",staticClass:"qr-wrapper"},[_c('img',{staticStyle:{"padding":"8px"},attrs:{"src":_vm.url,"alt":"QR Code"}}),_c('a',{attrs:{"href":_vm.url},on:{"click":function($event){$event.preventDefault();return _vm.downloadPDF(_vm.url)}}},[_vm._v("Download as PDF")])])
}
var staticRenderFns = []

export { render, staticRenderFns }